import type { ItemListId } from "../../tracking/create-ecommerce-event";

export const GAO_ITEM_LIST_IDS_STORAGE_KEY = "gao_item_list_ids";

export const writeGaoItemListIds = (map: Record<string, ItemListId>): void => {
  try {
    if (Object.keys(map).length === 0) return;
    sessionStorage.setItem(GAO_ITEM_LIST_IDS_STORAGE_KEY, JSON.stringify(map));
  } catch {
    // sessionStorage may be unavailable (SSR / private mode); ignore.
  }
};

export const readGaoItemListIds = (): Record<string, ItemListId> => {
  try {
    const raw = sessionStorage.getItem(GAO_ITEM_LIST_IDS_STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? (parsed as Record<string, ItemListId>) : {};
  } catch {
    return {};
  }
};

export const clearGaoItemListIds = (): void => {
  try {
    sessionStorage.removeItem(GAO_ITEM_LIST_IDS_STORAGE_KEY);
  } catch {
    // sessionStorage may be unavailable (SSR / private mode); ignore.
  }
};
